import { match, matchPath } from 'react-router'
import { createSelector } from 'reselect'
import {
  RemoveUserFromOrganizationMatchParams,
  removeUserFromOrganizationRouteProps,
} from 'src/navigation/routeProps'
import { selectMembersListModelsFromState } from 'src/redux/selectors/data/members.selectors'
import { selectLocationFromState } from 'src/redux/selectors/router.selectors'

export const selectUserIdFromRoute = createSelector(
  [selectLocationFromState],
  (location) => {
    const mtch = matchPath<RemoveUserFromOrganizationMatchParams>(
      location.pathname,
      removeUserFromOrganizationRouteProps,
    ) as match<RemoveUserFromOrganizationMatchParams>
    return mtch?.params.id
  },
)

export const selectOrganizationMember = createSelector(
  [selectMembersListModelsFromState, selectUserIdFromRoute],
  (members, userId) =>
    members[userId] !== undefined ? members[userId] : undefined,
)
